<template>
  <div
    ref="boxEl"
    :class="['pic-box',(isFullScreen ? 'pic-full-screen':'')]"
    @mousemove="picMouseMove"
  >
    <slot
      v-if="isLoading"
      name="loading"
    />
    <!--图片展示区域-->
    <div
      v-show="!isLoading && !isError"
      :class="['pic-display', isFullScreen? 'fullscreen-mode':'']"
    >
      <img
        v-if="picUrl"
        ref="imgEl"
        :style="[picRotate,picHeight,picMargin]"
        :src="picUrl"
        class="pic"
        @load="picLoad"
        @error="picError"
      >
    </div>
    <slot
      v-if="!isLoading && isError"
      name="error"
    >
      error
    </slot>
    <!--隐藏的toolbar-->
    <ul class="sideBar">
      <li
        id="zoomIn"
        @click="zoomIn"
      >
        +
      </li>
      <li id="zoomLevel">
        {{ zoom + '%' }}
      </li>
      <li
        id="zoomOut"
        @click="zoomOut"
      >
        -
      </li>
      <li
        id="pageRotateCw"
        @click="pageRotateCw"
      >
        cw
      </li>
      <li
        id="pageRotateCcw"
        @click="pageRotateCcw"
      >
        ccw
      </li>
      <li
        id="srcType"
        @click="changeSrcType"
      >
        {{ isOriginalType? $t('标准'):$t('原图') }}
      </li>
      <li
        id="presentationMode"
        @click="changeScreenMode"
      >
        mode
      </li>
    </ul>
    <co-toast
      ref="toastEl"
      v-model="toast.isShowToast"
      :toast-info="toast.message"
      :is-icon="toast.isIcon"
    />
  </div>
</template>
<script>
/**
* 1. 获取略缩图地址（loading 状态）
* 2. 定位当前index
* 3. 请求略缩图地址 （loading 状态）
* 4. onload （成功展示略缩图）
*       略缩图定位到中间
*       适配屏幕大小zoom程度
* 5. onerror （error状态）
* 6. P.S. 外链和网盘预览的查看原图走的接口不一样
*/
import coToast from 'components/common/toast/index.vue'
import _$ from 'js/api/getdata.js'
import { queryString, encodePath } from 'js/util/util'
import qs from 'qs'

export default {
  components: {
    coToast,
  },
  props: {
    src: { // 预览src
      type: String,
      default: '',
    },
    data: { // metaData信息
      type: Object,
      default: () => ({}),
    },
    checkPermission: { // 自定义方法，目前这里需要权限
      type: Function,
      default: () => true,
    },
    isOriginal: { // 自定义方法，验证是否已是原图
      type: Function,
      default: () => false,
    },
    /**
         * 是否是外链
         */
    isDelivery: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      picUrl: '', // image预览地址
      imgPos: { // 图片的定位
        top: 0,
        left: 0,
      },
      zoomStep: 5, // 每次zoom的步数
      isLoading: true, // loading状态
      isError: false, // error状态
      zoom: 0, // zoom level
      angle: 0, // roate angle
      isOriginalType: false, // 是否是原图
      isFullScreen: false, // 是否是全屏
      singleType: false, // 仅有一种格式，及原图
      toast: {
        isShowToast: false,
        isIcon: false,
        message: {
          info: '',
          tipsType: 'warn',
        },
      },
    }
  },
  computed: {
    /**
         * 有关的metadata
         */
    fileInfo() {
      return this.data || {}
    },
    /**
         * 用于图片旋转
         */
    picRotate() {
      return {
        transform: `rotate(${this.angle}deg)`,
        '-ms-transform': `rotate(${this.angle}deg)`,
        '-moz-transform': `rotate(${this.angle}deg)`,
        '-webkit-transform': `rotate(${this.angle}deg)`,
        '-o-transform': `rotate(${this.angle}deg)`,
      }
    },
    /**
         *  根据zoom，适配image的高度
         */
    picHeight() {
      const { imgEl } = this.$refs
      let height = 'auto'
      if (this.zoom) {
        height = `${Math.floor(this.zoom / 100 * imgEl.naturalHeight)}px`
      }
      return {
        height,
      }
    },
    /**
         *  根据图片高度宽度定位margin，以居中
         */
    picMargin() {
      return {
        // 'margin': `${this.imgPos.top}px auto 0`,
        'margin-top': `${this.imgPos.top}px`,
        'margin-left': `${this.imgPos.left}px`,
      }
    },
    /**
         * 右侧栏是否展开
         */
    isRightOpen() {
      return this.$store.state.isRightOpen
    },
  },
  watch: {
    /**
         * 监听右侧展开收缩
         */
    isRightOpen(val, oldVal) {
      if (!this.isError && !this.isLoading) {
        const flag = this.removeBoxAnimation()
        // 要是没有成功移除动画，则利用setTimeout，加动画的延迟400毫秒
        if (!flag) {
          setTimeout(() => {
            this.setImgPosition()
          }, 400)
          return
        }
      }
      this.$nextTick(() => {
        this.setImgPosition()
      })
    },
    /**
         * zoom变化，更新存储的store
         */
    zoom(val, oldVal) {
      this.storePicInfo()
    },
    /**
         * 监听资源src变化，prop
         */
    src: {
      immediate: true,
      handler(val) {
        if (val) {
          this.switchLabel = false
          if (val == '#' && this.isDelivery) { // 是外链 且 src为#，那就是超出预览上线,出现error
            this.isLoading = false
            this.isError = true
            // 提示 超出文件预览上限
            this.toast.message.info = this.$t('超出文件预览上限')
            this.toast.message.tipsType = 'warn'
            this.toast.isIcon = true
            this.toast.isShowToast = true
            return
          }
          this.isLoading = true
          this.isError = false
          // 当切换图片时，把toast关闭掉
          if (this.$refs.toastEl) {
            this.$refs.toastEl.closeToast()
          }
          // this.parseUrl(val);
          this.picUrl = val
          // 初始zoom, isOriginalType
          this.zoom = 0
          this.isOriginalType = val.indexOf('original') > -1
          this.storePicInfo()
        }
      },
    },
    isFullScreen(val, oldVal) {
      if (!this.isError && !this.isLoading) { // 切换全屏时会出现图片类型提醒
        this.switchLabel = true
      }
    },
  },
  destroyed() {
    document.removeEventListener('keyup', this.picOperation)
    window.removeEventListener('resize', this.picResize, false)
  },
  methods: {
    /**
         * 处理url，获取query
         */
    parseUrl(url) {
      const search = `?${url.split('?')[1]}`
      this.fileInfo = queryString(search)
    },
    /**
         * remove 外层的 Animation
         * 因为整理加了动画，有0.4s延迟，造成图片定位不更新，在这里暴力除去动画
         */
    removeBoxAnimation() {
      // .box-body-left 外链      .preview-box-body-main 网盘内的预览
      const wrapper = document.querySelector('.box-body-left') || document.querySelector('.preview-box-body-main')
      if (wrapper) {
        wrapper.classList.remove('common-transion')
        return true
      }
      return false
    },
    /**
         * image加载成功
         */
    picLoad() {
      this.isLoading = false
      this.isError = false
      this.setImgSetting()
      this.toastSrcType(this.isOriginalType) // 提示图片类型
      this.addListener() // 加载成功后，注册一些鼠标。键盘监听event
      if (this.isDelivery) {
        this.$emit('picLoad')
      }
    },
    /**
         * image加载失败
         */
    picError() {
      if (this.picUrl) {
        this.isLoading = false
        this.isError = true
      }
    },
    /**
         * 配置image，包括定位，比例
         */
    setImgSetting() {
      this.zoom = 100
      this.angle = 0
      if (this.isOriginalType) { // 原图不去zoom
        this.setImgPosition()
      } else { // 标准图适应大小
        this.$nextTick(() => {
          this.initialZoom()
        })
      }
    },
    /**
         * 加载成功后存储zoom level
         */
    storePicInfo() {
      const obj = {
        type: this.isOriginalType,
        zoom: this.zoom,
        isOriginal: this.isOriginal(),
      }
      this.$store.commit('GET_PREVIEW_INFO', obj)
    },
    /**
         * 监听窗口resize后的执行事件
         */
    picResize() {
      this.setImgPosition()
    },
    /**
         * 更新image位置
         */
    setImgPosition() {
      this.$nextTick(() => {
        this.setPicPos(this.$refs.imgEl, (top, left) => {
          this.imgPos.top = top
          this.imgPos.left = left
        })
      })
    },
    /**
         * 设置image位置
         */
    setPicPos(el, cb) {
      const picEl = el || this.$refs.imgEl
      const { boxEl } = this.$refs
      const picWidth = picEl.offsetWidth
      const picHeight = Math.floor(this.zoom / 100 * picEl.naturalHeight) || picEl.offsetHeight
      const top = Math.floor((boxEl.offsetHeight - picHeight) / 2)
      const left = Math.floor((boxEl.offsetWidth - picWidth) / 2)
      cb && cb(top, left)
    },
    /**
         * 初始化zoom level
         */
    initialZoom() {
      const { boxEl } = this.$refs
      const picEl = this.$refs.imgEl
      const picWidth = picEl.offsetWidth
      const picHeight = picEl.offsetHeight
      const widthZoom = (picWidth > boxEl.offsetWidth) ? (boxEl.offsetWidth / picWidth * 100) : this.zoom
      const heightZoom = (picHeight > boxEl.offsetHeight) ? (boxEl.offsetHeight / picHeight * 100) : this.zoom
      if (this.zoomStep === 0) {
        this.zoomStep = 5
      }
      this.zoom = (widthZoom < heightZoom) ? Math.floor(widthZoom / this.zoomStep) * this.zoomStep
        : Math.floor(heightZoom / this.zoomStep) * this.zoomStep // 每次zoom的step为5
      // console.log('boxEl, picEl, picWidth, picHeight, widthZoom, heightZoom=',boxEl, picEl, picWidth, picHeight, widthZoom, heightZoom)
      this.setImgPosition() // 初始zoom后图片定位
    },
    /**
         * change zoomStep
         */
    changeZoomStep() {
      if (this.zoom < 100) { // 小于100， 每次增加减少10
        this.zoomStep = 10
      } else if (this.zoom <= 200) { // 小于200， 每次增加减少25
        this.zoomStep = 25
      } else if (this.zoom <= 2000) { // 大于200， 每次增加减少50
        this.zoomStep = 50
      }
    },
    /**
         * zoom变化
         */
    zoomChange(zoomWay = 'in') {
      this.changeZoomStep()
      if (zoomWay === 'in') { // 放大
        if (this.zoom + this.zoomStep >= 2000) {
          this.zoomStep = 2000 - this.zoom
        }
        this.zoom >= 2000 ? '' : this.zoom += this.zoomStep
      } else {
        if (this.zoom - this.zoomStep <= 10) {
          this.zoomStep = this.zoom - 10
        }
        this.zoom <= 10 ? '' : this.zoom -= this.zoomStep
      }
      this.setImgPosition() // 变化zoom后图片定位
    },
    /**
         * rotate变化
         */
    rotateChange(angle) {
      this.angle += (angle)
    },
    /**
         * 放大
         */
    zoomIn() {
      if (this.isError || this.isLoading) return
      this.zoomChange('in')
    },
    /**
         * 缩小
         */
    zoomOut() {
      if (this.isError || this.isLoading) return
      this.zoomChange('out')
    },
    /**
         * 顺时针旋转
         */
    pageRotateCw() {
      if (this.isError || this.isLoading) return
      this.rotateChange(90)
    },
    /**
         * 逆时针旋转
         *
         */
    pageRotateCcw() {
      if (this.isError || this.isLoading) return
      this.rotateChange(-90)
    },
    /**
         * 提示当前的图片类型，原图 or 标准
         */
    toastSrcType(isOriginal) {
      if (!this.switchLabel) return // 标志-当全屏或切换类型时，才显示类型toast
      // 提示 目前已是原图
      if (isOriginal) {
        this.toast.message.info = this.$t('已显示原图')
      } else {
        this.toast.message.info = this.$t('已显示标准')
      }
      this.toast.message.tipsType = 'notice'
      this.toast.isIcon = false
      this.toast.isShowToast = true
    },
    /**
         * 改变图片类型，原图标准
         */
    changeSrcType() {
      this.switchLabel = true
      if (this.isOriginal() || this.src == '#') { // 如果已经是原图或者没有获取到图片地址，那点击切换类型，无效
        return
      }
      if (!this.isOriginalType) {
        if (!this.canPreviewOriginImg(this.fileInfo.path)) {
          // 提示 此格式文件无原图预览功能
          this.toast.message.info = this.$t('此格式文件无原图预览功能')
          this.toast.message.tipsType = 'warn'
          this.toast.isIcon = true
          this.toast.isShowToast = true
          return
        }
        if (!this.checkPermission()) {
          // 提示 此图片无法查看原图
          this.toast.message.info = this.$t('此图片无法查看原图')
          this.toast.message.tipsType = 'warn'
          this.toast.isIcon = true
          this.toast.isShowToast = true
          return
        }
        // 外链原图获取
        if (this.isDelivery) {
          this.getDeliveryOriPic()
          return
        }
        // 预览原因获取
        this.isLoading = true
        this.data.previewType = 'original'
        this.$emit('getOriginData', this.data)
      } else {
        this.data.previewType = ''
        this.$emit('getOriginData', this.data)
        this.isOriginalType = !this.isOriginalType
        // this.toastSrcType(this.isOriginalType);
        this.storePicInfo()
        this.zoom = 0
        this.isLoading = true
        this.picUrl = this.src
      }
    },
    /**
         * 外链时原图拼接字段
         */
    getDeliveryOriPic() {
      if (this.isDelivery) {
        this.zoom = 0
        this.isLoading = true
        if (!this.isOriginalType) {
          this.data.previewType = 'original'
          this.$emit('getOriginData', this.data)
        } else {
          this.data.previewType = ''
          this.$emit('getOriginData', this.data)
          this.isOriginalType = !this.isOriginalType
        }
        this.storePicInfo()
      }
    },
    /**
         * 预览时原图走下载
         */
    picFileDownload() {
      // 网盘内预览获取原图
      const urlBase = `/v2/dl_router/databox${encodePath(this.fileInfo.path)}`
      const params = {
        neid: this.fileInfo.neid,
        rev: this.fileInfo.rev,
        _: Date.parse(new Date()),
      }
      const url = `${urlBase}?${this.joinQueryData(params).substr(1)}`
      _$.getData(`${url}&probe=1`).then(() => { // 加probe=1为试探是否可以下载成功
        this.zoom = 0
        this.isOriginalType = !this.isOriginalType
        // this.toastSrcType(this.isOriginalType);
        this.storePicInfo()
        this.picUrl = `${url}&S=${this.$store.getters.S}`
      }).catch((err) => {
        // error
        this.isOriginalType = !this.isOriginalType
        this.storePicInfo()
        this.isLoading = false
        this.isError = true
      })
    },
    /**
         * 鼠标移动，会在全屏下显示footer
         */
    picMouseMove() {
      if (this.isFullScreen) {
        // let event = new CustomEvent('message');
        // window.dispatchEvent(event);
        window.postMessage('picMouseMove', '*')
      }
    },
    /**
         * 全屏切换
         */
    changeScreenMode() {
      this.isFullScreen = !this.isFullScreen
    },
    /**
         * 绑定键盘、鼠标、滚轮事件
         */
    addListener() {
      const vm = this
      const { imgEl, boxEl } = this.$refs
      // 键盘事件
      document.addEventListener('keyup', (e) => {
        const excludeElement = ['editing-box', 'el-textarea__inner']
        for (const key of excludeElement) {
          if (Array.from(e.target.classList).includes(key)) return
        }
        vm.picOperation(e)
      })
      // 全屏和退出事件
      // 滚轮事件
      this.addScrollListener()
      window.addEventListener('resize', vm.picResize)
      // 双击事件
      boxEl.ondblclick = (e) => {
        e.preventDefault()
        e.stopPropagation()
        vm.setImgSetting()
      }
      // 鼠标移动事件
      imgEl.onmousedown = function (e) {
        e.preventDefault()
        // 原始尺寸禁止拖拽图片位置
        const { imgEl, boxEl } = vm.$refs
        const ol = e.clientX - imgEl.offsetLeft
        const ot = e.clientY - imgEl.offsetTop
        // console.log('down---', e.clientX, e.clientY, imgEl.offsetLeft, imgEl.offsetTop, ol, ot)
        document.onmousemove = function (e) {
          const left = event.clientX - ol
          const top = event.clientY - ot
          const picHeight = boxEl.offsetHeight
          const picWidth = boxEl.offsetWidth
          // console.log('move---', picWidth, picHeight, left, top, event, event.clientX, event.clientY)
          if (imgEl.offsetHeight > picHeight) {
            let deltaY = top
            if (deltaY > 0) {
              deltaY = 0
            }
            if (deltaY < (picHeight - imgEl.offsetHeight)) {
              deltaY = picHeight - imgEl.offsetHeight
            }
            // console.log('h3',deltaY)
            vm.imgPos.top = deltaY
          }
          if (imgEl.offsetWidth > picWidth) {
            let deltaX = left
            if (deltaX > 0) {
              deltaX = 0
              // console.log('w1',deltaX)
            }
            if (deltaX < (picWidth - imgEl.offsetWidth)) {
              deltaX = picWidth - imgEl.offsetWidth
              // console.log('w2',deltaX)
            }
            // console.log('w3',deltaX)
            vm.imgPos.left = deltaX
          }
        }
        document.onmouseup = function (e) {
          document.onmousemove = null
          document.onmouseup = null
        }
      }
    },
    /**
         * 绑定鼠标滚动事件
         */
    addScrollListener() {
      const vm = this
      const { boxEl } = this.$refs
      const handle = function (delta) {
        if (delta < 0) { // 向下
          vm.zoomChange('in')
        } else { // 向上
          vm.zoomChange('out')
        }
      }
      const wheel = function (event) {
        let delta = 0
        if (!event) event = window.event
        if (event.wheelDelta) { // IE、chrome浏览器使用的是wheelDelta，并且值为“正负120”
          delta = event.wheelDelta / 120
          if (window.opera) delta = -delta// 因为IE、chrome等向下滚动是负值，FireFox是正值，为了处理一致性，在此取反处理
        } else if (event.detail) {
          // 用的是detail,其值为“正负3”
          delta = -event.detail / 3
        }
        if (delta) { handle(delta) }
      }
      boxEl.addEventListener('DOMMouseScroll', wheel, false)
      boxEl.onmousewheel = boxEl.onmousewheel = wheel
    },
    picOperation(e) {
      switch (e.keyCode) {
        case 38: // up
          this.zoomChange('in')
          break
        case 40: // down
          this.zoomChange('out')
          break
      }
    },
    /**
         * 判断该图片类型是否能查看原图
         * 支持原图预览的格式有 jpg;jpeg;png;bmp;gif
         * 传入文件名，如 img1.jpg或 img2.psd，返回true或false
         */
    canPreviewOriginImg(filename) {
      return /(jpg|jpeg|png|bmp|gif)/i.test(filename)
    },
    /**
         * 拼接query到url，可抽出来
         */
    joinQueryData(qryData) {
      const qryArr = ['']
      for (const key in qryData) {
        if (Object.prototype.hasOwnProperty.call(qryData, key)) {
          qryArr.push(`${key}=${encodeURIComponent(qryData[key])}`)
        }
      }
      return qryArr.join('&')
    },
  },
}
</script>
<style lang="less">
.pic-box{
  width: 100%;
  height: 100%;
  // background-color: #F6F7FA;
  background-color: #fff;
  position: relative;
  .auto-position{
    position: absolute;
    top: 50px;
  }
  .pic-display{
    width: 100%;
    height: 100%;
    overflow: hidden;
    .pic{
      display: block;
    }
  }
  .fullscreen-mode{
    background-color: #000000;
  }
  //sidebar不显示
  .sideBar{
    position: fixed;
    bottom: 60px;
    visibility: hidden;
    li{
      text-align: center;
      border: 1px solid;
      display: inline-block;
      width: 40px;
      height: 40px;
      line-height: 40px;
    }
  }
}
// 改变toast的位置
.pic-full-screen{
  .auto-position{
    top: 150px;
  }
  .notice{
    background-color: #484848;
    opacity: 0.8;
  }
}
</style>
